
import React from 'react';

const OfferFooter: React.FC = () => {
  return (
    <div className="mt-10 text-center text-xs text-gray-500">
      <p>© {new Date().getFullYear()} All rights reserved.</p>
      <p className="mt-2">
        <a href="/terms" className="text-blue-500 hover:underline mx-2">Terms of Service</a>
        <a href="/privacy" className="text-blue-500 hover:underline mx-2">Privacy Policy</a>
      </p>
    </div>
  );
};

export default OfferFooter;
